import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Breadcrumb,
  Card,
  Skeleton,
  Button,
  Form,
  Modal,
  Tabs,
} from 'antd';
import { Link } from 'react-router-dom';
import OneRowData from 'components/OneRowData';
import moment from 'moment';
import get from 'lodash/get';

import { formatDateTimeDetailWib } from 'shared/utils/StringUtil';
import { permissionService } from 'shared/services';

import PartnerDetailTncForm from './PartnerDetailTnC.form.component';
import deliveryRoute from '../../route';

import text from './PartnerDetail.page.translation';
import './PartnerDetail.style.less';

const PartnerDetailTnc = Form.create()(PartnerDetailTncForm);
const { TabPane } = Tabs;
const { checkPermission } = permissionService;

class PartnerDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTnC: false,
      activeTabKey: 'en',
    };
  }

  _renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Row className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(text.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{formatMessage(text.partnerDetail)}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    );
  };

  _renderRowData = (data, key) => <OneRowData key={key} data={data} />;

  _onChangeTabs = tabKey => {
    this.setState({
      activeTabKey: tabKey,
    });
  };

  _renderPartnerInfo = () => {
    const {
      loading,
      intl: { formatMessage },
      partnerDetail,
    } = this.props;

    const leftData = [
      {
        label: formatMessage(text.info.name),
        value: get(partnerDetail, 'name', '-'),
      },
      {
        label: formatMessage(text.info.id),
        value: get(partnerDetail, 'id', '-'),
      },
      {
        label: formatMessage(text.info.logo),
        url: get(partnerDetail, 'logo', '-'),
        inline: true,
        style: {
          width: '200px',
          height: '80px',
          borderWidth: 0,
        },
      },
    ];
    const leftRowData = leftData.map(this._renderRowData);

    const rightData = [
      {
        label: formatMessage(text.info.created),
        value: formatDateTimeDetailWib(get(partnerDetail, 'created_at', '-')),
      },
      {
        label: formatMessage(text.info.updated),
        value: formatDateTimeDetailWib(get(partnerDetail, 'updated_at', '-')),
      },
    ];
    const rightRowData = rightData.map(this._renderRowData);

    return (
      <Card title={formatMessage(text.info.title)}>
        <Row type="flex">
          <Card.Grid>
            <Skeleton
              loading={loading}
              active
              paragraph={{ rows: 7, width: ['100%', '100%'] }}
              title={false}
            >
              {leftRowData}
            </Skeleton>
          </Card.Grid>
          <Card.Grid>
            <Skeleton
              loading={loading}
              active
              paragraph={{ rows: 7, width: ['100%', '100%'] }}
              title={false}
            >
              {rightRowData}
            </Skeleton>
          </Card.Grid>
        </Row>
      </Card>
    );
  };

  getServiceTags = service => get(service, 'tag') || [];

  _renderServiceItem = (service, index, data) => {
    const {
      intl: { formatMessage },
    } = this.props;

    const serviceTags = this.getServiceTags(service);
    const etaDuration = get(service, 'eta_duration', '');
    const etaUnit = get(service, 'eta_unit', '');
    const etaDisplay =
      etaUnit && etaDuration ? `${etaDuration} ${etaUnit}` : '-';

    const leftData = [
      {
        label: formatMessage(text.service.name),
        value: get(service, 'name', '-'),
      },
      {
        label: formatMessage(text.service.type),
        value: get(service, 'type', '-'),
      },
      {
        label: formatMessage(text.service.tag),
        value: serviceTags.map((tag, idx) => (idx === 0 ? tag : `, ${tag}`)),
      },
    ];
    const leftRowData = leftData.map(this._renderRowData);

    const rightData = [
      {
        label: formatMessage(text.service.eta),
        value: etaDisplay,
      },
      {
        label: formatMessage(text.service.time),
        value: `${moment(get(service, 'start_time', '-'), 'HH:mm:ss').format(
          'HH:mm',
        )} - ${moment(get(service, 'end_time', '-'), 'HH:mm:ss').format(
          'HH:mm',
        )} WIB`,
      },
      {
        label: formatMessage(text.service.enabled),
        value: service.is_enable ? 'Yes' : 'No',
      },
    ];
    const rightRowData = rightData.map(this._renderRowData);

    const serviceLogoUrl = get(service, 'logo', '');

    const titleBasicInformation = this.renderTitleDivider(
      formatMessage(text.service.basicInformation),
    );

    const packageTypeDescription = this.renderPackageTypeDesc(service);

    const serviceDivider =
      index === data.length - 1 ? null : this.renderServiceDivider();

    return (
      <div key={service.id}>
        {titleBasicInformation}
        <div className="service-logo">Service Logo</div>
        <img className="service-img" src={serviceLogoUrl} alt="service-logo" />
        <Row className="service-row">
          <div className="service-col">{leftRowData}</div>
          <div className="service-col">{rightRowData}</div>
          {!service.is_enable && (
            <div
              style={{
                background: 'rgba(255,255,255,0.5)',
                position: 'absolute',
                width: '100%',
                height: '98%',
              }}
            />
          )}
        </Row>
        {packageTypeDescription}
        {serviceDivider}
      </div>
    );
  };

  _renderPartnerService = () => {
    const {
      loading,
      intl: { formatMessage },
      partnerDetail,
    } = this.props;

    return (
      <Card title={formatMessage(text.service.title)}>
        <Skeleton
          loading={loading}
          active
          paragraph={{ rows: 7, width: ['100%', '100%'] }}
          title={false}
        >
          <div>
            <Tabs
              onChange={this._onChangeTabs}
              type="card"
              tabBarGutter={16}
              className="language-tabs"
            >
              <TabPane tab="English" key="en"></TabPane>
              <TabPane tab="Indonesian" key="id"></TabPane>
            </Tabs>
            <div className="tabs-divider" />
          </div>
          {get(partnerDetail, 'services', []).map(this._renderServiceItem)}
        </Skeleton>
      </Card>
    );
  };

  _onBack = () => {
    this.props.history.goBack();
  };

  _onEdit = () => {
    const { history, match } = this.props;

    const path = deliveryRoute.PARTNER_EDIT.replace(':id', match.params.id);
    history.push(path);
  };
  _toggleShowTnC = showTnC => () => {
    this.setState({ showTnC });
  };

  _onValidateSuccess = payload => {
    const {
      updatePartner,
      partnerDetail: { id },
    } = this.props;
    updatePartner(id, payload, this._updateTncSuccessCallback, true);
  };

  _updateTncSuccessCallback = () => {
    this.setState({
      showTnC: false,
    });
    this.props.getPartnerDetail(this.props.match.params.id);
  };

  _renderBtnDetail = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    const canEditPartner = checkPermission('Partner Management:update', true);

    return (
      <div className="partner-detail-btn">
        <Button type="default" className="btn" onClick={this._onBack}>
          {formatMessage(text.btn.back)}
        </Button>

        {canEditPartner && (
          <Button type="primary" className="btn" onClick={this._onEdit}>
            {formatMessage(text.btn.edit)}
          </Button>
        )}
        <Button
          type="primary"
          className="btn"
          onClick={this._toggleShowTnC(true)}
        >
          {formatMessage(text.btn.viewTnC)}
        </Button>
      </div>
    );
  };

  _renderPartnerDetailInfo = () => (
    <div className="white-box-wrapper">
      {this._renderPartnerInfo()}
      {this._renderPartnerService()}
      {this._renderBtnDetail()}
    </div>
  );

  renderModalTitle = () => (
    <Row className="modal-title-form-builder">
      {this.props.intl.formatMessage(text.tnc)}
    </Row>
  );

  renderTitleDivider = title => (
    <div className="service-information">
      <div className="label-container">{title}</div>
      <div className="line-container">
        <div className="line" />
      </div>
    </div>
  );

  renderServiceDivider = () => <div className="service-divider"></div>;

  renderPackageTypeDesc = service => {
    const typeDescriptions = get(
      service,
      'additional_info.type_descriptions',
      [],
    );

    if (typeDescriptions.length > 0) {
      const {
        intl: { formatMessage },
      } = this.props;

      const content = typeDescriptions.map(x => this.renderPackageTypeItems(x));

      const titlePackageTypeDescription = this.renderTitleDivider(
        formatMessage(text.service.packageTypeDesc),
      );

      return (
        <div>
          {titlePackageTypeDescription}
          <Row>{content}</Row>
        </div>
      );
    }

    return null;
  };

  renderPackageTypeItems = item => {
    const typeName = get(item, 'type', '');
    const descEn = get(item, 'description.en', '');
    const descId = get(item, 'description.id', '');

    const title = `Package Type Description: ${typeName}`;
    const description = this.state.activeTabKey === 'en' ? descEn : descId;

    return (
      <Col span={12} key={typeName} className="pkg-type-container">
        <div className="pkg-type-title">{title}</div>
        <div className="pkg-type-desc">{description}</div>
      </Col>
    );
  };

  componentDidMount() {
    this.props.getPartnerDetail(this.props.match.params.id);
  }

  render() {
    return (
      <div className="main-content partner-detail-main-wrapper">
        {this._renderBreadCrumb()}
        {this._renderPartnerDetailInfo()}
        <Modal
          title={this.renderModalTitle()}
          visible={this.state.showTnC}
          footer={null}
          destroyOnClose
          onCancel={this._toggleShowTnC(false)}
          className="modal-create"
        >
          <PartnerDetailTnc
            onBack={this._toggleShowTnC(false)}
            id={this.props.partnerDetail.id}
            tnc={this.props.partnerDetail.tnc}
            onValidateSuccess={this._onValidateSuccess}
            loading={this.props.loading}
          />
        </Modal>
      </div>
    );
  }
}

PartnerDetail.propTypes = {
  intl: PropTypes.object,
  loading: PropTypes.bool,
  history: PropTypes.object,
  getPartnerDetail: PropTypes.func,
  updatePartner: PropTypes.func,
  partnerDetail: PropTypes.object,
  match: PropTypes.object,
};

export default PartnerDetail;
